<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<style lang="scss" scoped>
.container10 {
  margin-top: 80px;
}
.container10 h1 {
  font-size: 70px;
  color: #014492;
}
.container10 h2 {
  font-size: 40px;
  color: #014492;
}
.cons {
  display: none;
}
.container10 .a {
  width: 800px;
  height: 6px;
  margin-top: 30px;
  margin-bottom: 40px;
  background: #ccc;
  position: relative;
}
.container10 .a span {
  width: 50px;
  height: 6px;
  position: absolute;
  left: 0;
  top: 0;
  background: #014492;
}
.no-indent {
  .desc {
    text-indent: 0;
  }
}
.wrap-tec .lists li {
  width: 33.3%;
}
@media screen and (max-width: 640px) {
  .wrap-tec .lists li {
    width: 100% !important;
    p {
      margin: 5px auto !important;
    }
  }
}
</style>
<template>
  <div class="wrap wrap-tec">
    <!--    <div class="banner">-->
    <!--      <img src="@/assets/images/banner_17.png" class="img-fluid">-->
    <!--      <div class="info">-->
    <!--        <div class="container">-->
    <!--          <h1>IncRNA测序</h1>-->
    <!--          <h2 class="mt10">lncRNA sequencing</h2>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="container container10">
      <h1>lncRNA测序</h1>
      <h2 class="mt10">lncRNA Sequencing</h2>
      <div class="a"><span></span></div>
    </div>
    <div
      class="breads container"
      style="overflow: auto; line-height: 48px; padding-left: 10px"
    >
      <bread></bread>
    </div>
    <section class="container">
      <p class="desc">
        长链非编码RNA（long non-coding RNA）是一类大于 200 bp的非编码
        RNA，位于细胞核或细胞质内。通过染色体修饰与DNA、RNA或蛋白质结合，在表观遗传、转录及转录后等水平调控基因表达。
      </p>
      <p class="desc">
        LncRNA测序通过构建去 rRNA 链特异性文库可针对有参基因组的物种鉴定已知
        lncRNA、预测新的 lncRNA 和靶基因分析，同时提供 mRNA 的分析以及 lncRNA 和
        mRNA 的比较分析、共表达网络构建，且测序结果包含 circRNA
        部分，可以进一步分析 circRNA 表达谱及 circRNA-mRNA 互作网络分析。
      </p>
      <en-title title="应用领域" enTitle="Application" />
      <application-icon :iconList="iconList" :lines="1.5" menuTitle="lncRNA测序"/>
      <en-title title="技术参数" enTitle="Specifications" />
      <ul class="lists">
        <li>
          <img src="@/assets/images/prokaryotic_icon_4.png" />
          <h4>测序平台及策略</h4>
          <p>Novaseq PE150</p>
        </li>
        <li>
          <img src="@/assets/images/prokaryotic_icon_8.png" />
          <h4>项目周期</h4>
          <p>30个工作日</p>
        </li>
        <!-- <li>
          <img src="@/assets/images/prokaryotic_icon_6.png">
          <h4>测量数据量</h4>
          <p>20 G</p>
        </li> -->
        <li>
          <img src="@/assets/images/prokaryotic_icon_7.png" />
          <h4>数据质量</h4>
          <p>Q30＞80%，Q20＞85%</p>
        </li>
      </ul>
      <en-title title="技术路线" enTitle="Testing Workflow" />
      <div class="tc con"><img src="@/assets/images/inc_1.png" /></div>
      <div class="tc cons" style="margin-top: 20px">
        <img src="@/assets/images/inc_1.png" />
      </div>
      <en-title title="研究内容" enTitle="Bioinformatics Service" />
      <service-table
        :tableColumn="tableColumn"
        :tableData="tableData"
        :headerCellStyle="headerCellStyle"
      />
    </section>
    <new-consult
      title="样本制备与寄样"
      enTitle="Sample Requirement and Shipment"
      :samplingText="samplingText"
      :typeList="['sampling']"
    />
    <!-- <qk-consult type="Virus"/> -->
  </div>
</template>
<script>
import bread from "@/components/bread";
import ServiceTable from "./components/serviceTable";
import ApplicationIcon from "./components/applicationIcon";
export default {
  inject: ["reload"],
  components: {
    bread,
    ServiceTable,
    ApplicationIcon,
  },
  data() {
    return {
      samplingText:
        "擎科生物lncRNA测序目前接收细胞、动物组织、植物组织、真菌菌体、血液等组织样本与提取好的total RNA。",
      tableColumn: [
        {
          prop: "method1",
          html: true,
        },
        {
          label: "长链非编码RNA标准生信分析",
          prop: "method2",
          html: true,
        },
      ],
      tableData: [
        {
          method1: `1) 测序数据过滤和质量评估（过滤过程中去除核糖体rRNA序列）`,
          method2: `6) 功能分析<p class="ml17 mt10">差异基因GO，KEGG功能注释</p>`,
        },
        {
          method1: `2) 比对参考序列（比对统计、测序随机性评估、比对上序列在基因区域的分布）`,
          method2: `7) 联合分析
                    <p class="ml17 mt10">7.1 lncRNA与mRNA特征分析（lncRNA与mRNA长度分布统计，lncRNA与mRNA外显子个数分布统计）</p>
                    <p class="ml17 mt10">7.2 组织特异性分析</p>`,
        },
        {
          method1: `3) 转录本拼接`,
          method2: `8)  差异lncRNA靶标预测分析
                    <p class="ml17 mt10">8.1 差异 lncRNA的Cis作用靶标预测</p>
                    <p class="ml17 mt10">8.2 差异 lncRNA的Trans靶标预测（多样本数据，样本数>5）</p>
                    <p class="ml17 mt10">8.3 差异 lncRNA靶标基因的GO，KEGG功能注释</p>
                    <p class="ml17 mt10">8.4 lncRNA和mRNA的互作网络</p>`,
        },
        {
          method1: `4) lncRNA筛选及编码潜能预测`,
          method2: `9) 可变剪切分析（可变剪切事件分类统计）`,
        },
        {
          method1: `5) 表达量分析
                    <p class="ml17 mt10">5.1 基因表达量估计（表达量分布，数据饱和度分析）</p>
                    <p class="ml17 mt10">5.2 差异表达分析（差异表达基因统计、聚类图及注释信息）</p>`,
          method2: `10)  SNP和INDEL检测`,
        },
      ],
      iconList: [
        {
          img:'ngs_second/transcriptome/lncRNA/icon_1',
          title:'细胞分化和发育的研究',
        },
        {
          img:'ngs_second/transcriptome/lncRNA/icon_2',
          title:'调控机理的研究',
        },
        {
          img:'ngs_second/transcriptome/lncRNA/icon_3',
          title:'疾病标志物的寻找',
        },
        {
          img:'ngs_second/transcriptome/lncRNA/icon_4',
          title:'疾病的分子诊断',
        },
        {
          img:'ngs_second/transcriptome/lncRNA/icon_5',
          title:'基因药物的研发',
        },
      ],
    };
  },
  created() {
    this.reload();
  },
  methods: {
    headerCellStyle({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        row[1].colSpan = 2;
        if (columnIndex === 0) {
          return {
            display: "none",
          };
        }
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/tec/lncRNA.vue